import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { ApiUrlConstants } from 'src/app/shared/common/ApiUrlConstants';

@Injectable({
  providedIn: 'root',
})
export class CreateServiceDispatchService {
  constructor(private webApiService: WebApiService) {}

  createServiceDispatch(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.createServiceDispatch,
      reqBody
    );
  }

  fetchServiceDispatchDetails(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchServiceDispatchDetailsByDispatchIdAndInvoiceId,
      reqBody
    );
  }

  fetchServiceDispatchDetailsByDispatchId(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchServiceDispatchDetailsByDispatchId,
      reqBody
    );
  }

  deleteServiceDispatchAttachment(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.deleteServiceDispatchAttachment,
      reqBody
    );
  }

  fetchServiceInvoiceDetailsById(invoiceId: number) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchServiceInvoiceDetailsById,
      { invoiceId }
    );
  }
}
